import { Link, useNavigate } from 'react-router'
import { Skeleton } from '../../../platform/async/Skeleton'
import type { AsyncState } from '../../../platform/async/Async'
import { formatStaleDate } from '../../accounts/accountsStaleLabels'
import { BUDGET_PATH, budgetDetailPath } from '../../budget/budgetPaths'
import { EnvelopeColumn } from '../../budget/EnvelopeColumn'
import type { Envelope } from '../../budget/useBudgets'
import { OverviewWidget } from '../OverviewWidget'

/**
 * Budget envelopes (intake A13): a row of vertical columns, one per active monthly
 * envelope, as the design draws it. The percentage and both flags are the server's
 * own; there is no amount-left figure (`amount − spent` is a subtraction). The
 * column is M4's own `EnvelopeColumn`. Over and close are said in the meter's
 * value text and with a sign beside the figure, never colour alone (rule 11).
 */
export function BudgetWidget({ state }: { state: AsyncState<Envelope[]> }) {
  const navigate = useNavigate()
  return (
    <OverviewWidget<Envelope[]>
      title="Budget envelopes"
      subtitle="Monthly envelopes"
      href={BUDGET_PATH}
      surface="budgets"
      fill
      staleLabel={(asOf) => `Budget progress from ${formatStaleDate(asOf)}`}
      state={state}
      skeleton={
        <>
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
        </>
      }
      empty={{ title: 'No envelopes yet', action: { label: 'Set up a budget', onAct: () => void navigate(BUDGET_PATH) } }}
    >
      {(envelopes) => (
        <ul className="ov-cols">
          {envelopes.map((e) => (
            <li key={e.id} className="ov-cols__item">
              <Link to={budgetDetailPath(e.id)} className="ov-cols__link">
                <EnvelopeColumn envelope={e} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </OverviewWidget>
  )
}
